import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, Building2, Wrench, Users, Calculator, FileSpreadsheet, ShieldCheck, Smartphone } from "lucide-react";

export default function Landing() {
  return (
    <div className="min-h-screen bg-background">
      <header className="h-16 border-b border-border flex items-center justify-between px-6 lg:px-12 sticky top-0 bg-background/90 backdrop-blur z-30">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-primary text-primary-foreground grid place-items-center"><Home className="w-4 h-4" /></div>
          <span className="font-heading font-bold text-xl">Rent</span>
        </div>
        <div className="flex items-center gap-2">
          <Link to="/login"><Button variant="ghost" data-testid="header-login-btn">Connexion</Button></Link>
          <Link to="/register"><Button className="rounded-full" data-testid="header-register-btn">Commencer</Button></Link>
        </div>
      </header>

      <section className="px-6 lg:px-12 py-16 lg:py-24 max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <span className="inline-block text-xs font-semibold px-3 py-1.5 rounded-full bg-accent text-accent-foreground mb-6">
            Gestion locative LMNP / LMP
          </span>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05]">
            La gestion locative meublée, de A à Z.
          </h1>
          <p className="mt-6 text-base lg:text-lg text-muted-foreground max-w-lg">
            Biens, baux, candidatures, maintenance, encaissement des loyers, comptabilité et liasse fiscale 2031.
            Propriétaires, mainteneurs, candidats et locataires — chacun son espace.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/register"><Button size="lg" className="rounded-full" data-testid="hero-cta-btn">Créer mon compte</Button></Link>
            <Link to="/login"><Button size="lg" variant="outline" className="rounded-full" data-testid="hero-login-btn">J'ai déjà un compte</Button></Link>
          </div>
          <p className="mt-4 text-xs text-muted-foreground flex items-center gap-1.5">
            <Smartphone className="w-3.5 h-3.5" /> Installable sur iPhone & Android depuis le navigateur
          </p>
        </div>
        <div className="rounded-2xl overflow-hidden border border-border shadow-sm">
          <img
            src="https://images.pexels.com/photos/6636314/pexels-photo-6636314.jpeg"
            alt="Bien meublé"
            className="w-full h-[420px] object-cover"
          />
        </div>
      </section>

      <section className="px-6 lg:px-12 pb-24 max-w-6xl mx-auto">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            [Building2, "Gestion des biens", "Fiches complètes de vos logements meublés, valeur d'acquisition et statut."],
            [Users, "Candidatures & baux", "Recevez les candidatures, générez les baux et l'échéancier des loyers."],
            [Wrench, "Maintenance", "Tickets d'intervention affectés aux mainteneurs, suivi en temps réel."],
            [Calculator, "Comptabilité", "Recettes, charges et import de relevés bancaires en un clic."],
            [FileSpreadsheet, "Liasse fiscale 2031", "Amortissements calculés et export PDF prêt pour votre déclaration."],
            [ShieldCheck, "4 espaces sécurisés", "Propriétaire, mainteneur, candidat et locataire — accès dédiés."],
          ].map(([Icon, title, desc], i) => (
            <div key={i} className="p-6 rounded-xl border border-border bg-card transition-transform hover:-translate-y-1">
              <Icon className="w-6 h-6 text-[hsl(var(--ring))]" />
              <h3 className="font-heading font-semibold text-xl mt-4">{title}</h3>
              <p className="text-sm text-muted-foreground mt-2">{desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
